import { gramsPer } from '@zilian/contracts';

/** One material of a product: weighed ones take parts of the piece weight, counted ones so many per piece. */
export interface RecipeLine {
  skuId: string;
  ratio: string;
}

interface Unit {
  unit: string;
}

export const byWeight = (sku?: Unit) => !!sku && gramsPer(sku.unit) !== null;

/**
 * The parts each line takes and their sum. A lone weighed material takes the whole weight,
 * whatever its parts say, so it is never asked for one.
 */
export function partsFor(lines: RecipeLine[], skuOf: (id: string) => Unit | undefined) {
  const weighed = lines.filter((l) => l.skuId && byWeight(skuOf(l.skuId)));
  const lone = weighed.length === 1;
  const partsOf = (line: RecipeLine) =>
    byWeight(skuOf(line.skuId)) && lone ? 1 : Number(line.ratio) || 0;
  const total = weighed.reduce((sum, l) => sum + partsOf(l), 0);
  /** Share of the piece weight as a percentage to one decimal, or null before parts are known. */
  const percent = (line: RecipeLine) =>
    total && partsOf(line) ? Math.round((partsOf(line) / total) * 1000) / 10 : null;
  return { weighed, lone, partsOf, total, percent };
}
